module.exports = __webpack_public_path__ + "95a288299dcd71e17257cc80dfec6a6c.fbx";